const CONSENT_KEY = "proshare_tracking_consent";

export const getTrackingConsent = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(CONSENT_KEY) === "true";
};

export const setTrackingConsent = (granted) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CONSENT_KEY, granted ? "true" : "false");
  window.dispatchEvent(
    new CustomEvent("proshare:tracking-consent-changed", {
      detail: { granted: Boolean(granted) },
    })
  );
};

export const hasStoredTrackingConsent = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(CONSENT_KEY) !== null;
};
